import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/commerce";
export default function SecteurCommerce() { return <SectorLayout data={data} />; }
